// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__fY30o","logo":"Navigation_logo__2b_w_"};